import * as yup from 'yup';

import BannerSettingsPresenter from '../presenters/BannerSettingsPresenter';

import { REQUIRED, INCORRECT_FORMAT } from './errorsText';

const HEX_CODE_PATTERN = /^#[0-9A-Fa-f]{6}$/;

export const validationFields = {
  title: yup.string().required(REQUIRED),
  text: yup.string().required(REQUIRED),
  fontColor: yup.string().matches(HEX_CODE_PATTERN, INCORRECT_FORMAT),
  backgroundColor: yup.string().matches(HEX_CODE_PATTERN, INCORRECT_FORMAT),
  bannerType: yup.string().required(REQUIRED),
  imageUrl: yup.string(),
  submitButtonColor: yup.string().matches(HEX_CODE_PATTERN, INCORRECT_FORMAT),
  submitButtonText: yup.string().required(REQUIRED),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (settings) => {
  return {
    title: BannerSettingsPresenter.title(settings) || '',
    text: BannerSettingsPresenter.text(settings) || '',
    bannerType: BannerSettingsPresenter.bannerType(settings) || '',
    fontColor: BannerSettingsPresenter.fontColor(settings) || '',
    backgroundColor: BannerSettingsPresenter.backgroundColor(settings) || '',
    imageUrl: BannerSettingsPresenter.imageUrl(settings) || '',
    submitButtonColor:
      BannerSettingsPresenter.submitButtonColor(settings) || '',
    submitButtonText: BannerSettingsPresenter.submitButtonText(settings) || '',
    image: {},
  };
};
